import React from 'react';
import { connect } from 'react-redux';
import translate from './TranslateHOC';
import { default as GlobalNavV2 } from '../v2/components/globalNav/GlobalNav';
import { switchLanguage } from '../actions';
import { useHasScrolled } from '../hooks/useScrollNavVisibility';
import { grabCurrentPath } from '../helpers';
import {
  PATH_SIGN_IN,
  PATH_SIGN_UP,
  PATH_FORGOT,
  PATH_FORGOT_UPDATE,
} from '../constants';

function GlobalNav({ auth, strings, location, curLang, switchLang }) {
  const isSignInUp =
    grabCurrentPath() === PATH_SIGN_IN ||
    grabCurrentPath() === PATH_SIGN_UP ||
    grabCurrentPath() === PATH_FORGOT ||
    grabCurrentPath().includes(PATH_FORGOT_UPDATE) ||
    grabCurrentPath() === '/tv' ||
    grabCurrentPath() === '/linc' ||
    grabCurrentPath() === '/link';
  const hasScrolled = useHasScrolled(76);

  if (isSignInUp) {
    return null;
  }

  return (
    <GlobalNavV2
      auth={auth}
      strings={strings}
      location={location}
      changeLang={() => switchLang(curLang)}
      scrollNavHidden={hasScrolled}
    />
  );
}

function mapStateToProps(state) {
  return {
    curLang: state.curLang,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    switchLang: (lang) => dispatch(switchLanguage(lang)),
  };
};

export default translate(
  connect(mapStateToProps, mapDispatchToProps)(GlobalNav)
);
